module.exports = __webpack_public_path__ + "static/thumb-fpo-a3861dcacc715f7516954175b4b40413.png";